import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzSwitchComponent } from "ng-zorro-antd/switch";

@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [
    NzSwitchComponent,
    FormsModule
  ],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
]})
export class ToggleComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() subtitle: string = '';
  @Input() toggleId: string = 'toggle';
  @Input() isActive: boolean = false;
  @Input() disable: boolean = false;

  @Output() toggleChange = new EventEmitter<boolean>(); //TODO: REMOVE THIS AND USE THE isActiveChange for two way binging
  @Output() isActiveChange = new EventEmitter<boolean>();

  private formDisabled: boolean = false;

  get isDisabled(): boolean {
    return this.disable || this.formDisabled;
  }

  onChange = (value: boolean) => {};
  onTouched = () => {};

  toggleActive(): void {
    if (this.isDisabled) return;
    this.isActive = !this.isActive;
    this.onChange(this.isActive);
    this.onTouched();
    this.toggleChange.emit(this.isActive);
    this.isActiveChange.emit(this.isActive);
  }

  writeValue(value: boolean): void {
    this.isActive = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.formDisabled = isDisabled;
  }

}
